import { useBriefSetMultiTextMutation } from './briefSetMultiText.generated';
import { useUpdateField } from './useUpdateField';

export function useUpdateMultiTextField(
    key: string,
    briefId?: string,
    initialValue?: string[] | null
) {
    const [setText] = useBriefSetMultiTextMutation();
    return useUpdateField<string | string[]>({ key, setField: setText, briefId, initialValue });
}
